import { BaseAPIModel } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';
/**
 * Chart.
 *
 * @param {Object} params - Object parameter
 * @constructor
 */
export default class Chart extends BaseAPIModel {
    fields() {
        return {
            uuid: { readOnly: true, primaryKey: true },
            name: {},
            pacifa_key: {},
            preview_picture: { readOnly: true }
        };
    }

    static listUrl({ organizationId }) {
        if (!organizationId) {
            throw new ArgumentError('[Model][Chart] organizationId is mandatory');
        }
        return `/ticket/organizations/${organizationId}/charts`;
    }

    duplicate(data, params) {
        const url = `${this.constructor.getItemUrl(params)}/duplicate`;
        return this.constructor.fetcher.post(url, { data });
    }
}
